// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Restaumatic_Form_GenerateId from "../Restaumatic.Form.GenerateId/index.js";
var EntityId = function (x) {
    return x;
};
var ufromJSONKey = Data_UUID.ufromJSONKeyUUID;
var udecodeEntityId = Data_UUID.udecodeUUID;
var showEntityId = Data_UUID.showUUID;
var ordEntityId = Data_UUID.ordUUID;
var newtypeEntityId = {
    Coercible0: function () {
        return undefined;
    }
};
var genericEntityId = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var generateEntityId = Restaumatic_Form_GenerateId.generateUUID;
var eqEntityId = Data_UUID.eqUUID;
var encodeEntityId = Data_UUID.encodeUUID;
var decodeEntityId = Data_UUID.decodeUUID;
var asJSONKeyEntityId = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyString((function () {
            var $10 = Data_Newtype.unwrap();
            return function ($11) {
                return Data_UUID.toString($10($11));
            };
        })(), (function () {
            var $12 = Data_Maybe.maybe(Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("invalid UUID")))((function () {
                var $14 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
                var $15 = Data_Newtype.wrap();
                return function ($16) {
                    return $14($15($16));
                };
            })());
            return function ($13) {
                return $12(Data_UUID.fromString($13));
            };
        })())
    };
})();
export {
    EntityId,
    genericEntityId,
    newtypeEntityId,
    showEntityId,
    eqEntityId,
    ordEntityId,
    decodeEntityId,
    udecodeEntityId,
    ufromJSONKey,
    encodeEntityId,
    generateEntityId,
    asJSONKeyEntityId
};
